export enum TipoGenero {
  FEMENINO = 'F',
  MASCULINO = 'M',
}
